// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rai-texting-list{overflow:auto}.rai-txt--desktop .rai-txt-detail{overflow-y:scroll}", ""]);
// Exports
module.exports = exports;
